export default __webpack_public_path__ + "static/Enquiry-814c9d7b33d50669f648ace34a1488e6.jpg";